module.exports = __webpack_public_path__ + "static/scale-model-of-ladybug-building-in-milwaukee-wisconsin-bc18bb48fac2dd37fd04433c89ddbee9.png";